import React, { useState, useRef } from 'react'; // 'useState' foi adicionado aqui
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, IconButton, CircularProgress } from '@mui/material'; // 'Box' foi removido
import CloseIcon from '@mui/icons-material/Close';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FichaCheckin from './FichaCheckin';

// Imports para gerar PDF
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const FichaCheckinModal = ({ open, onClose, reserva, hospede, despesasExtras }) => {
  const [loadingPdf, setLoadingPdf] = useState(false);
  const fichaRef = useRef(null);

  const handleGerarPDF = async () => {
    setLoadingPdf(true);
    const input = fichaRef.current;
    if (input) {
      try {
        const canvas = await html2canvas(input, { scale: 2 });
        const imgData = canvas.toDataURL('image/png');
        
        const pdf = new jsPDF({
          orientation: 'portrait',
          unit: 'mm',
          format: 'a4'
        });

        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
        
        pdf.addImage(imgData, 'PNG', 10, 10, pdfWidth - 20, pdfHeight - 20);
        pdf.save(`Ficha-Check-in-${reserva.hospedeNome}.pdf`);

      } catch (error) {
        console.error("Erro ao gerar PDF:", error);
      } finally {
        setLoadingPdf(false);
      }
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Visualizar Ficha de Check-in
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div ref={fichaRef}>
          <FichaCheckin reserva={reserva} hospede={hospede} despesasExtras={despesasExtras} />
        </div>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit">Fechar</Button>
        <Button 
          onClick={handleGerarPDF} 
          variant="contained" 
          startIcon={loadingPdf ? <CircularProgress size={20} color="inherit" /> : <PictureAsPdfIcon />}
          disabled={loadingPdf}
        >
          {loadingPdf ? 'Gerando...' : 'Gerar PDF'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FichaCheckinModal;